var _ = require('optimizely-client-fn');

var PromiseEnv = require('core/lib/promise');
var WindowEnv = require('core/env/window');
var Logger = require('core/utils/logger');
var constants = require('./constants');
var fns = require('./fns');

var VENDOR = 'google_analytics_4_audience_targeting';
var field = 'client_id';

var pluginAudienceGA4: AudiencePluginConfig = {
  provider: {
    isAsync: true,
    isLazy: true,
    getter: [
      'stores/global',
      'stores/integration_settings',
      /**
       * @returns {Object}
       */
      function (GlobalStore, IntegrationSettingsStore) {
        const url = __GA4_AUDIENCE_EXTRACTION_URL__;

        const projectId = GlobalStore.getProjectId();
        const integrationSettings = IntegrationSettingsStore.get(VENDOR);

        if(_.isEmpty(projectId)) {
          return PromiseEnv.reject(fns.createGA4Error('GA4Audience missing projectId'));
        }

        let ga4IdType = integrationSettings?.ga4_id_type;
        if (_.isEmpty(ga4IdType)) {
            const idFieldFromSettings = integrationSettings?.ga4_user_id;
            if(!_.isEmpty(idFieldFromSettings)){
              ga4IdType = constants.GA4_ID_TYPE_USER_ID;
            } else {
              ga4IdType = constants.GA4_ID_TYPE_DEVICE_ID;
            }
        }

        let ga4UserId: any;
        let ga4DeviceId: any;
        if (ga4IdType === constants.GA4_ID_TYPE_USER_ID) {
          const idFieldFromSettings = integrationSettings?.ga4_user_id;
          Logger.log(`GA4Audience using ${idFieldFromSettings} to retrieve GA4 userID`);

          if(!_.isEmpty(idFieldFromSettings)){
              const globalUserId = WindowEnv.getGlobalByPath(idFieldFromSettings);
              Logger.log(`GA4Audience got GA4 userID from window: ${globalUserId}`);
              ga4UserId = typeof globalUserId === 'function' ? globalUserId.call() : globalUserId;
          }else{
              Logger.warn('GA4Audience Could not find User ID variable from integration settings, attempting to read ga4_user_id value from global store');
              const pushApiUserId = GlobalStore.getGA4UserId();
              ga4UserId = typeof pushApiUserId === 'function' ? pushApiUserId.call() : pushApiUserId;
          }
          if(_.isEmpty(ga4UserId)){
            Logger.warn('GA4Audience could not find User ID variable missing, attempting to use deviceID');
          }else{
            Logger.log(`GA4Audience using GA4 userID ${ga4UserId}`);
          }
        } else {
          window['optimizely'] = window['optimizely'] || [];
          ga4DeviceId = fns.getGACookie();
        }

        const dataLayerObj = fns.getDataLayer();
        const tagId = fns.getTagId(dataLayerObj);
        const gtagFnPromise = fns.getGtagFn();

        let source = 'GA4audience';

        if((ga4IdType === constants.GA4_ID_TYPE_USER_ID) && ( (_.isEmpty(dataLayerObj) || dataLayerObj?.length === 0) || _.isEmpty(tagId) )) {
          return fns.callMakeAsyncRequest({source, url, projectId, ga4UserId});
        }
        if ((ga4IdType === constants.GA4_ID_TYPE_DEVICE_ID) && !_.isEmpty(ga4DeviceId)) {
          return fns.callMakeAsyncRequest({source, url, projectId, ga4UserId: null, ga4DeviceId});
        }

        if(!ga4UserId && dataLayerObj?.length > 0 && _.isEmpty(tagId)) {
          return PromiseEnv.reject(fns.createGA4Error('GA4Audience tagId missing'));
        }

        let deviceIdPromise = fns.getGAClientIdFromGtagFn(gtagFnPromise, tagId, field);

        // eslint-disable-next-line @typescript-eslint/no-shadow
        return deviceIdPromise.then(function (ga4DeviceId) {
          return fns.callMakeAsyncRequest({source, url, projectId, ga4UserId, ga4DeviceId});
        });

      },
    ],
  },

  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function (PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceGA4);
};

if (__TEST__) {
  module.exports = pluginAudienceGA4;
}
